import { useLayoutEffect, useRef } from "react";

/** Keeps a ref pointed at the latest value so callbacks/effects can read it
 *  without being re-created on every change. The ref updates after render but
 *  before paint (no render-phase mutation, so it's safe under concurrent
 *  rendering). Read `.current` from event handlers, effects, or async
 *  callbacks — not synchronously during render, where it still holds the
 *  previous value. */
export const useLatestRef = <T>(value: T) => {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
};
